import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getTournaments } from "../tournament/actions";
import { getAllTeams, getTeams } from "./actions";

export const teamEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = teamEntityAdapter.getInitialState({
  teamsCountByCategory: 0,
  modals: {},
});

export const teamSlice = createSlice({
  name: "team",
  initialState: initialState,
  reducers: {
    showTeamAddModal: (state, action) => {
      state.modals.teamAddModal = action.payload;
    },
    showTeamDeleteModal: (state, action) => {
      state.modals.teamDeleteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTournaments.fulfilled, (state, action) => {
      if (action.payload.success) {
        if (action.payload.entities?.team) {
          teamEntityAdapter.setAll(state, action.payload.entities.team);
        }
      }
    });

    builder.addCase(getAllTeams.fulfilled, (state, action) => {
      if (action.payload.success) {
        if (action.payload?.teams) {
          if (action.meta.arg.requestType === "append") {
            teamEntityAdapter.addMany(state, action.payload.teams);
          } else {
            teamEntityAdapter.setAll(state, action.payload.teams);
          }
        }
      }
    });

    builder.addCase(getTeams.fulfilled, (state, action) => {
      const shouldUpdateState = action?.meta?.arg?.shouldUpdateState ?? true;

      if (shouldUpdateState) {
        if (action.payload.success && action.payload.entities?.team) {
          teamEntityAdapter.setAll(state, action.payload.entities?.team);
          state.teamsCountByCategory = action.payload?.totalCount;
        } else {
          state.ids = [];
          state.teamsCountByCategory = 0;
        }
      }
    });
  },
});

export const { showTeamAddModal, showTeamDeleteModal } = teamSlice.actions;

export default teamSlice.reducer;
